module.exports = __webpack_public_path__ + "img/14.7a9a599c.svg";